export const STREET_ARTICLES = new Set([
  'de',
  'du',
  'des',
  'la',
  'le',
  'les',
  'au',
  'aux',
  'l',
  'd',
])
